"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnSelector = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const Select_1 = require("../../../components/Select");
const AdaptableContext_1 = require("../../AdaptableContext");
const ColumnSelector = function (props) {
    var _a;
    const { api } = (0, AdaptableContext_1.useAdaptable)();
    const columns = React.useMemo(() => {
        return api.columnApi.getColumnsOfType(props.type);
    }, []);
    const getColumn = (columnId) => columns.find((c) => c.columnId === columnId);
    const options = columns
        .map((column) => {
        var _a;
        return ({
            label: (_a = column.friendlyName) !== null && _a !== void 0 ? _a : column.columnId,
            value: column.columnId,
        });
    })
        .filter((option) => {
        if (props.filterColumn) {
            return props.filterColumn(getColumn(option.value));
        }
        return true;
    });
    return (React.createElement(Select_1.Select, { "data-name": "column-selector", disabled: props.disabled, isMulti: props.isMulti, menuPosition: props.menuPosition, value: props.value, placeholder: (_a = props.placeholder) !== null && _a !== void 0 ? _a : 'Select Column', onChange: (colId) => {
            props.onChange(colId);
        }, options: options }));
};
exports.ColumnSelector = ColumnSelector;
